import {apiUrl, apiUrlV2} from "../constants/apiUrl";

const createUserSlice = (set, get) => ({
  graphRange: '1Y',
  isGraphHappy: false,
  isOnline: true,
  showSidebar: false,
  appMessage: null,
  hideGraph: true,
  unitRowStyle: 'lg',
  collapsedSections: {
    dealersWithRepos: true,
    dealersWithReviews: true,
    soldUnits: true,
    unitsPastDue: true,
    dealersWithFieldAudits: true,
    untouchedSixtyDays: true
  },
  actionButton: null,
  topNavHidden: false,
  navBarHidden: false,
  acceptingTermsOfService: false,
  pushNotificationEnabled: false,
  userLocation: {latitude: null, longitude: null},
  breadcrumbTrail: [{label: 'Dashboard', path: '/'}],
  setBreadcrumbTrail: (trail) => set({breadcrumbTrail: trail}),
  resetBreadcrumbTrail: () => set({breadcrumbTrail: [{label: 'Dashboard', path: '/'}]}),
  setGraphRange: (range) => set((state) => ({graphRange: range})),
  setIsGraphHappy: (range) => set((state) => ({isGraphHappy: range})),
  setIsOnline: (isOnline) => set((state) => ({isOnline: isOnline})),
  setShowSidebar: (show) => set((state) => ({showSidebar: show})),
  setPushNotificationEnabled: (enabled) => set((state) => ({pushNotificationEnabled: enabled})),
  setErrMessage: (message, buttonOptions = null) => set((state) => ({
    appMessage: {
      message: message,
      buttonOptions: buttonOptions,
      type: 'error'
    }
  })),
  setAlertMessage: (message, buttonOptions = null) => set((state) => ({
    appMessage: {
      message: message,
      buttonOptions: buttonOptions,
      type: 'alert'
    }
  })),
  setSuccessMessage: (message, buttonOptions = null) => set((state) => ({
    appMessage: {
      message: message,
      buttonOptions: buttonOptions,
      type: 'success'
    }
  })),
  resetMessages: () => set((state) => ({appMessage: null})),
  toggleHideGraph: () => set((state) => ({hideGraph: !state.hideGraph})),
  setUnitRowStyle: (style) => set(() => ({unitRowStyle: style})),
  toggleCollapsedSection: (section) => set((state) => ({
    collapsedSections: {
      ...state.collapsedSections,
      [section]: !state.collapsedSections[section]
    }
  })),
  resetCollapsedSections: () => set((state) => ({
    collapsedSections: {
      dealersWithRepos: true,
      dealersWithReviews: true,
      soldUnits: true,
      unitsPastDue: true,
      dealersWithFieldAudits: true,
      untouchedSixtyDays: true,
      unreconciledFieldAudits: true
    }
  })),
  setActionButton: (actionButton) => set((state) => ({actionButton: actionButton})),
  setTopNavHidden: (topNavHidden) => set((state) => ({topNavHidden: topNavHidden})),
  setNavBarHidden: (navBarHidden) => set((state) => ({navBarHidden: navBarHidden})),
  setUserLocation: (location) => set((state) => ({userLocation: location})),
  acceptTermsOfService: async (userId, dealerId) => {
    set(() => ({acceptingTermsOfService: true}))
    try {
      const response = await fetch(`${apiUrlV2}/dealer_users/${userId}/accept_new_terms`, {
        method: 'PUT',
        headers: get().requestHeaders,
        body: JSON.stringify({
          dealer_id: dealerId
        })
      })
      const data = await response.json()

      console.log('old user:', get().user)
      console.log('new data:', data.data)
      set((state) => ({
        user: {
          ...state.user,
          accepted_new_terms_at: new Date().toISOString()
        }
      }))
      get().fetchDealer(dealerId)
    } catch (err) {
      get().logError('There was an error accepting terms of service.', err)
    } finally {
      set(() => ({acceptingTermsOfService: false}))
    }
  },
})

export default createUserSlice